function setupMoneyFormatFilter() {
    window.Vue.filter('moneyFormat', value => {
        if (!value) {
            return value;
        }

        const currency = window.app.currency;

        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency
        }).format(value);
    });
}

export default setupMoneyFormatFilter;